<mat-form-field
	[color]="color"
	[appearance]="appearance"
	[floatLabel]="floatLabel"
	[ngClass]="{
		hasError: __hasError,
		'full-width': takeFullWidth
	}"
>
	<mat-label
		[ngClass]="{
			'label-error': __hasError
		}"
		>{{ label }}</mat-label
	>
	<trycatch-mat-auto-complete
		[formControl]="_control"
		[placeholder]="placeholder"
		[options]="options"
		[displayProperty]="displayProperty"
		[displayFn]="displayFn"
		[charThreshold]="charThreshold"
		[optionDisplayFn]="optionDisplayFn"
		[optionClassFn]="optionClassFn"
		[required]="required"
		[options$]="options$"
		[focusedElement]="focused"
		(optionSelected)="_optionSelected($event)"
		(inputChanged)="_inputChanged($event)"
		[classList]="classList"
		[label]="label"
		[maxLength]="maxLength"
		[customPanelWidth]="customPanelWidth"
		[dealWithNullKeyOption]="dealWithNullKeyOption"
		[borderBottom]="borderBottom"
	>
	</trycatch-mat-auto-complete>

	<mat-hint [innerHtml]="hint ? hint : ''"></mat-hint>
	<mat-error [innerHtml]="error"></mat-error>
	<img *ngIf="showImage" class="valid-tick" [src]="imageUrl" />
</mat-form-field>
